import {AssessmentResult} from '../../shared/models/assessment-result';
import { Injectable } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';
import { Question } from 'app/shared/models/question';
import { QuestionSet } from 'app/shared/models/question-set';

@Injectable()
export class PclGraderService {
  

  constructor() {
  this
   }
  
  // TODO: stephen look at caching these results...
  getPCLCriteriaFromAssessmentResult(assessmentResult:AssessmentResult) {

    let questionSetsByQuestion:Map<Question, QuestionSet> = new Map<Question, QuestionSet>();

    assessmentResult.assessment
    .question_sets.forEach(qs => qs.questions
    .forEach(q => questionSetsByQuestion.set(q, qs)));

    return assessmentResult.scaleResults.map(sr => {
      let questions = assessmentResult.assessment.getQuestionsForScale(sr.scale);
      let hasPTSD = this.checkScaleForPTSD(sr, questions, questionSetsByQuestion);
      return {
        name: this.getShortName(sr.scale.name), hasPTSD: hasPTSD, scaleResult: sr
      }
    });
  }

  private getShortName(criteriaName:string) {
    return criteriaName.replace("Criteria ", "");
  }

  private checkScaleForPTSD(scaleResult:ScaleResult, questions:Question[], questionSetsByQuestion:Map<Question, QuestionSet>) {
    // no point in checking if the score is 0
    if (scaleResult.score <= 0) {
      return false;
    }
    // @see https://www.ptsd.va.gov/professional/assessment/documents/using-PCL5.pdf
    // for the grading criteria

    // Labels are 0 Not at all, 1 = A little bit, 2 = Moderate, 3 Quite a bit, 4 = Extremely
    // so a score of 2 for a single question trigger works, or a label index of 2 for two questions works
    // on the other criteria

    // on the simple criteria they only have to answer 1 question to mark it as PTSD
    if (scaleResult.scale.id == '6cfb2519-68af-1a4a-32bf-25db6b71d904' // criteria B
        || scaleResult.scale.id == '8b4e65f1-12d3-22aa-23d5-edccd6bccd68') // criteria C 
    {
      return scaleResult.score > 0;
    }
    // the other criteria require at least one answer (which in this case is an answer > the default of Not at all)
    else if (scaleResult.scale.id == '4870117d-27af-a6fe-9d25-ee568cca6c47' // criteria D
        || scaleResult.scale.id == '48b296d3-101a-e80e-5205-9ff01f832bf8')  // criteria E
    {
        let matchedQuestions = questions.map(q => {
          let questionSet = questionSetsByQuestion.get(q);
          let labelIndex = questionSet.labels.findIndex(l => q.answerForSave == l.id);
          return labelIndex >= 2;
        }).filter(result => result);

        return matchedQuestions.length > 2;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/services/pcl-grader.service.ts